import { StatusPointsState } from '../../models/loyalty/status-points.state';
import {
  StatusPointsActions,
  GET_STATUS_POINTS,
  GET_STATUS_POINTS_SUCCESS,
  GET_STATUS_POINTS_ERROR
} from '../../actions/loyalty/actions-status-points';

export const statusPointsState: StatusPointsState = {
  data: {
    addArray: [],
    firstUsername: '',
    points: [],
    rdpoints: null,
    refresh: 0,
    totlegsOK: 0,
    totpoints: 0,
    useArray: [],
    details: '1',
    fromDate: null,
    ispnr: 'test',
    isvaluepnr: 'test',
    name: 'points',
    noneDet: 'none',
    pnrSearch: 'test',
    requestId: '',
    summAdd: 0,
    summUse: 0,
    text: '',
    title: '',
    toDate: null,
    expired: 0
  },
  code: 9,
  message: '',
  isLoading: false,
  loadingError: ''
};

/* eslint-disable */
export function reducersStatusPoints(state = statusPointsState, action: StatusPointsActions): StatusPointsState {
  switch (action.type) {
    case GET_STATUS_POINTS:
      return { ...state, isLoading: true, loadingError: '' };

    case GET_STATUS_POINTS_SUCCESS:
      return { ...action.payload, isLoading: false, loadingError: '' };

    case GET_STATUS_POINTS_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    default:
      return state;
  }
}
